export default "<div class=\"ccc-twitter-timeline\">\n  <ccc-loader class=\"automatic\" size=\"3\"></ccc-loader>\n  <div class=\"timeline\"></div>\n</div>\n";